import { createStyles, IconButton, makeStyles } from '@material-ui/core';
import { CloudDownload } from '@material-ui/icons';
import React from 'react';
import { useDocumentData, useLocalization } from "../../hooks/index.js";
const useStyles = makeStyles(() => {
  return createStyles({
    iconButton: {
      display: 'inline-block'
    },
    icon: {}
  });
});

/**
 * Component that allows download
 */
export const Download = props => {
  const classes = useStyles(props);
  const localization = useLocalization();
  const {
    documentData
  } = useDocumentData();
  return /*#__PURE__*/React.createElement(IconButton, {
    className: classes.iconButton,
    color: "inherit",
    title: localization.download,
    onClick: () => props.download(documentData),
    id: "CloudDownload"
  }, /*#__PURE__*/React.createElement(CloudDownload, {
    className: classes.icon
  }));
};
//# sourceMappingURL=download-widget.js.map